export default [
  {
    path: '/indicador-prazos',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Indicador Prazos Histórico',
        path: 'historico',
        component: () => import('@/views/indicadorPrazos/Historico'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            {
              name: 'Power Ups',
              path: '/powerups'
            },
            {
              name: 'Indicador de Prazos'
            }
          ]
        }
      },
      {
        name: 'Indicador Prazos Adicionar',
        path: 'edit',
        component: () => import('@/views/indicadorPrazos/Edit'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            {
              name: 'Power Ups',
              path: '/powerups'
            },
            {
              name: 'Indicador de Prazos',
              path: '/indicador-prazos/historico'
            },
            {
              name: 'Adicionar'
            }
          ]
        }
      },
      {
        name: 'Indicador Prazos Editar',
        path: 'edit/:id',
        component: () => import('@/views/indicadorPrazos/Edit'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            {
              name: 'Power Ups',
              path: '/powerups'
            },
            {
              name: 'Indicador de Prazos',
              path: '/indicador-prazos/historico'
            },
            {
              name: 'Editar'
            }
          ]
        }
      }
    ]
  }
];
